import API from '../services/api';

let instance = null;
const api = new API();

const URL_INTEGRATION_REQUESTS = 'api/partner-integration/request/';

export default class IntegrationRequestService {
    constructor() {
        if (!instance) {
            instance = this;
        }
        return instance;
    }

    getIntegrationRequests() {
        return api
            .getJson(URL_INTEGRATION_REQUESTS, {
                method: 'GET',
                credentials: 'include',
                unique: true,
            })
            .then(response => {
                if (response.status !== 0) {
                    throw new Error(response.value || 'Failed to fetch integration requests');
                }
                const body = response.value;
                if (body && Array.isArray(body.requests)) {
                    return {
                        requests: body.requests,
                        postbackMacroNetworkName: body.postback_macro_network_name ?? null,
                    };
                }
                return { requests: [], postbackMacroNetworkName: null };
            });
    }

    createIntegrationRequest({ requestType, formData = {} }) {
        const body = {
            request_type: requestType,
            form_data: formData,
        };
        return api
            .getJson(URL_INTEGRATION_REQUESTS, {
                method: 'POST',
                credentials: 'include',
                unique: true,
                body,
            })
            .then(response => {
                if (response.status !== 0) {
                    throw new Error(response.value || 'Failed to create integration request');
                }
                return response.value;
            });
    }

    updateIntegrationRequest(integrationRequestId, { formData }) {
        const body = { form_data: formData };
        return api
            .getJson(`${URL_INTEGRATION_REQUESTS}${integrationRequestId}/`, {
                method: 'PUT',
                credentials: 'include',
                unique: true,
                body,
            })
            .then(response => {
                if (response.status !== 0) {
                    throw new Error(response.value || 'Failed to update integration request');
                }
                return response.value;
            });
    }

    submitIntegrationRequest(integrationRequestId) {
        return api
            .getJson(`${URL_INTEGRATION_REQUESTS}${integrationRequestId}/submit/`, {
                method: 'POST',
                credentials: 'include',
                unique: true,
            })
            .then(response => {
                if (response.status !== 0) {
                    throw new Error(response.value || 'Failed to submit integration request');
                }
                return response.value;
            });
    }

    validatePostbackUrl(url) {
        return api
            .getJson(`${URL_INTEGRATION_REQUESTS}validate-url/`, {
                method: 'POST',
                credentials: 'include',
                unique: true,
                body: { url },
            })
            .then(response => {
                if (response.status !== 0) {
                    throw new Error(response.value || 'Failed to validate URL');
                }
                return response.value;
            });
    }

    archiveIntegrationRequest(integrationRequestId) {
        return api
            .getJson(`${URL_INTEGRATION_REQUESTS}${integrationRequestId}/`, {
                method: 'DELETE',
                credentials: 'include',
                unique: true,
            })
            .then(response => {
                if (response.status !== 0) {
                    throw new Error(response.value || 'Failed to archive integration request');
                }
                return response.value;
            });
    }
}
